<template>
	<div :style="{ '--container-width': containerWidth + 'px' }">
		<div class="section py-0">
			<div ref="headerContainer" class="container">
			</div>
		</div>
		<Splide ref="splideRef" :options="splideOptions" :extensions="extensions" :has-track="false" aria-label="Client Reviews">
			<SplideTrack>
				<slot></slot>
			</SplideTrack>
		</Splide>
	</div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { Splide, SplideTrack } from '@splidejs/vue-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const extensions = { AutoScroll };

const splideRef = ref(null);
const headerContainer = ref(null);
const containerWidth = ref(0);
const windowWidth = ref(window.innerWidth);

const currentGap = computed(() => {
	if (windowWidth.value < 768) return 16;
	if (windowWidth.value < 1024) return 20;
	return 24;
});

const splideOptions = reactive({
	type: 'loop',
	gap: '24px',
	autoWidth: true,
	pagination: false,
	arrows: false,
	drag: true,
	autoScroll: {
		speed: 0.5,
		pauseOnHover: true,
		pauseOnFocus: false,
	},
});

function calcPadding() {
	if (!headerContainer.value) return;
	const rect = headerContainer.value.getBoundingClientRect();
	containerWidth.value = rect.width;
	splideOptions.padding = {
		left: rect.left,
		right: window.innerWidth - rect.right,
	};
}

let resizeObserver;

onMounted(() => {
	calcPadding();
	splideOptions.gap = currentGap.value + 'px';
	resizeObserver = new ResizeObserver(() => {
		windowWidth.value = window.innerWidth;
		splideOptions.gap = currentGap.value + 'px';
		calcPadding();
	});
	resizeObserver.observe(document.documentElement);
});

onBeforeUnmount(() => {
	resizeObserver?.disconnect();
});
</script>
